import styled from 'styled-components';
import Colors from '../../../constants/Colors';

export const MainContainer = styled.div`
    background-color: ${Colors.BACKGROUND_COLOR};
    height: 100vh;
`;